export class ClassificationEmployeur {
    id: number|undefined;
    active:boolean;
    code:string;
    label:string;
  }